import { render, staticRenderFns } from "./SinisterProduct.vue?vue&type=template&id=76502b5d"
import script from "./SinisterProduct.vue?vue&type=script&lang=ts"
export * from "./SinisterProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports